import { inlineElements, size } from '../constants';
export const isBlockElement = element => element && inlineElements.indexOf(element.type) === -1 && typeof element !== 'string';
export const spaceSetting = _ref => {
  let {
    verticalSpacing = 'sm',
    horizontalSpacing = 'sm',
    children = [],
    flex = false
  } = _ref;
  const verticalMargin = (size[verticalSpacing] || 0) / (flex ? 2 : 1);
  return `
    margin: 0px -${(size[horizontalSpacing] || 0) / 2}px;

    ${isBlockElement(children[0]) || flex ? `margin-top: -${verticalMargin}px;` : ''}
    ${isBlockElement(children[children.length - 1]) || flex ? `margin-bottom: -${verticalMargin}px;` : ''}

    > * {
      margin: ${verticalMargin}px ${(size[horizontalSpacing] || 0) / 2}px;
    }
  `;
};
export const isEmptyObject = obj => Object.keys(obj).length === 0 && obj.constructor === Object;
//# sourceMappingURL=index.js.map